import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { CFCProps } from 'types';
import { RootState } from 'redux/root.reducer';
import { ToastNotification } from 'carbon-components-react';
import { removeAlert } from 'redux/alerts/actions';

const GlobalToastAlerts: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { alertsCache } = props;
  return (
    <div
      className={`toast-container${
        alertsCache.data.length > 0 ? ' has-alert' : ''
      }`}
    >
      {alertsCache.data
        .filter((alert: any) => alert.type !== 'inline')
        .map((alert: any) => {
          const { id, kind, message, details, timeout, stayForever } = alert;
          if (!stayForever) {
            const removeTime = timeout ? timeout + 1000 : 11000;
            setTimeout(() => dispatch(removeAlert(id)), removeTime);
          }
          return (
            <ToastNotification
              key={id}
              kind={kind}
              title={message}
              caption={details}
              timeout={!stayForever ? timeout || 10000 : undefined}
              onCloseButtonClick={() => dispatch(removeAlert(id))}
            />
          );
        })}
    </div>
  );
};

const mapStateToProps = ({ alertsCache }: RootState) => ({
  alertsCache
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector>;

GlobalToastAlerts.displayName = 'GlobalToastAlerts';

export default connector(GlobalToastAlerts);
